import { web3 } from '@project-serum/anchor'
import { stakeBanxNft } from 'fbonds-core/lib/fbond-protocol/functions/banxStaking/banxTokenStaking'
import { mapBanxToPoints } from 'fbonds-core/lib/fbond-protocol/functions/staking/settings'
import { CreateTxnData, WalletAndConnection } from 'solana-transactions-executor'

import { staking } from '@banx/api/common'
import { BANX_STAKING, BONDS, IS_SDK_ON_DEV_CONTRACT } from '@banx/constants'

import { sendTxnPlaceHolder } from '../helpers'

type CreateStakeBanxNftTxnDataParams = {
  nft: staking.BanxNftStake
  createStakeAccount: boolean
}
type CreateStakeBanxNftTxnData = (
  params: CreateStakeBanxNftTxnDataParams,
  walletAndConnection: WalletAndConnection,
) => Promise<CreateTxnData<CreateStakeBanxNftTxnDataParams>>

export const createStakeBanxNftTxnData: CreateStakeBanxNftTxnData = async (
  params,
  walletAndConnection,
) => {
  const { nft, createStakeAccount } = params

  const instructions: web3.TransactionInstruction[] = []
  const signers: web3.Signer[] = []

  if (IS_SDK_ON_DEV_CONTRACT) {
    const mapBanxToPointsResult = await mapBanxToPoints({
      programId: new web3.PublicKey(BONDS.PROGRAM_PUBKEY),
      connection: walletAndConnection.connection,
      args: {
        playerPoints: nft.meta.playerPoints || 0,
        partnerPoints: nft.meta.partnerPoints || 0,
      },
      accounts: {
        userPubkey: walletAndConnection.wallet.publicKey,
        nftMint: new web3.PublicKey(nft.mint),
      },
      sendTxn: sendTxnPlaceHolder,
    })

    instructions.push(...mapBanxToPointsResult.instructions)
    signers.push(...mapBanxToPointsResult.signers)
  }

  const stakeBanxNftResult = await stakeBanxNft({
    connection: walletAndConnection.connection,
    programId: new web3.PublicKey(BONDS.PROGRAM_PUBKEY),
    accounts: {
      tokenMint: new web3.PublicKey(nft.mint),
      whitelistEntry: new web3.PublicKey(BANX_STAKING.WHITELIST_ENTRY_PUBKEY),
      hadoRegistry: new web3.PublicKey(BANX_STAKING.HADO_REGISTRY_PUBKEY),
      userPubkey: walletAndConnection.wallet.publicKey,
    },
    args: {
      createStakeAccount,
    },
    sendTxn: sendTxnPlaceHolder,
  })

  instructions.push(...stakeBanxNftResult.instructions)
  signers.push(...stakeBanxNftResult.signers)

  const accounts: web3.PublicKey[] = [
    stakeBanxNftResult.accounts['banxStake'],
    stakeBanxNftResult.accounts['banxStakingSettings'],
    stakeBanxNftResult.accounts['banxTokenStake'],
    stakeBanxNftResult.accounts['advenureSubscriptions'],
    ...[
      stakeBanxNftResult.accounts['adventureCurrentWeek'],
      stakeBanxNftResult.accounts['adventureNextWeek'],
    ],
  ]

  return {
    accounts,
    params,
    instructions,
    signers: signers,
    lookupTables: [],
  }
}
